import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import TruncatedTooltip from '@databases/atlaskit/TruncatedTooltip';
import { messages } from '@databases/intl/messages';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

const titleStyles = xcss({
  display: 'block',
  maxWidth: '100%',
  minWidth: '0',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});

type DatabaseEntryTitleProps = {
  title?: string;
  headingLevel: 'h1' | 'h2';
};

const DatabaseEntryTitle: FunctionComponent<DatabaseEntryTitleProps> = ({
  title,
  headingLevel
}) => {
  const { formatMessage } = useIntl();
  const resolvedTitle =
    title && title.trim().length > 0
      ? title
      : formatMessage(messages['unnamed-entities.unnamed-entry']);

  return (
    <TruncatedTooltip content={resolvedTitle}>
      <Heading as={headingLevel} size="medium" testId="database-entry-title">
        <Box as="span" xcss={titleStyles}>
          {resolvedTitle}
        </Box>
      </Heading>
    </TruncatedTooltip>
  );
};

export default DatabaseEntryTitle;
